export default __webpack_public_path__ + "static/media/sandFooter.9fe5b27d.svg";